/**
 *
 * Entities reducer getter
 */
export const getEntitiesReducer = state => state.entities;

export const getFilteredMentionReducer = state => state.filtered_mention;
